document.addEventListener('turbolinks:load', function () {
  $('body').on('click', '.sort-button', function (e) {
    // clicks on the column header's ellipsis menu
    // shouldn't trigger a sort
    if ($(e.target).closest('.column-header-menu').length) return;

    $('.filterLoader').addClass('active');
    var btn = $(this);
    var sortField = $('#filterrific_sorted_by');
    if (btn.hasClass('desc')) {
      btn.removeClass('desc');
      btn.addClass('asc');
      sortField.val(`${btn.data('sort')}_asc`);
    } else {
      btn.removeClass('asc');
      btn.addClass('desc');
      sortField.val(`${btn.data('sort')}_desc`);
    }
    $(this).toggleClass('');
    submitFilter('#filterrific_filter');
  });
});
